import type { NextPage, GetServerSideProps } from 'next'
import Image from 'next/legacy/image'
import { PageTemplate, RecommendedDocuments } from '../../components'
import { Layout } from '../../components/Layout'
import {
  EventPageContent,
  PageConfig,
  RecommendedDocumentsProps
} from '../../types/page_component_types'
import { Locale } from '../../types/shared_types'
import { getPagePropsBySlug } from '../../utils/get_page_props_by_slug'

const EventPage: NextPage<{
  pageContent?: EventPageContent
  pageConfig: PageConfig
  recommendations: RecommendedDocumentsProps[]
  availableLocales?: string[]
}> = ({ pageContent, pageConfig, recommendations, availableLocales }) => {
  const eventStart =
    pageContent?.time?.starttime && new Date(pageContent?.time?.starttime)

  return (
    <Layout
      config={pageConfig}
      meta={pageContent?.meta}
      slug={pageContent?.slug}
      availableLocales={availableLocales}
    >
      {eventStart && eventStart <= new Date(2022, 8, 15) && (
        // Only show the hero image for events before Sep 15th 2022 -> old website layout
        <div className="mx-auto max-w-[70.5rem]">
          <Image
            src={pageContent?.image?.src}
            alt={pageContent?.image?.alt}
            layout="responsive"
            objectFit="contain"
            // Our max container width is 1440px
            width="1440"
            height="1080"
          />
        </div>
      )}
      <PageTemplate {...pageContent} />
      <RecommendedDocuments
        recommendations={recommendations}
        config={pageConfig.recommendedConfig}
      />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await getPagePropsBySlug(context, '/events', {
    with_recommendations: true
  })
}

export default EventPage
